import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChangeHistory = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 18,
	height: 18,
	fill: "none",
	viewBox: "0 0 18 18",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#BFC8CB",
		d: "M9 18c-2.3 0-4.304-.762-6.013-2.287C1.28 14.188.3 12.283.05 10H2.1c.233 1.733 1.004 3.167 2.312 4.3C5.721 15.433 7.25 16 9 16c1.95 0 3.604-.68 4.963-2.037C15.32 12.604 16 10.95 16 9c0-1.95-.68-3.604-2.037-4.963C12.604 2.68 10.95 2 9 2a6.75 6.75 0 0 0-3.225.8A7.431 7.431 0 0 0 3.25 5H6v2H0V1h2v2.35A8.732 8.732 0 0 1 5.112.875 8.93 8.93 0 0 1 9 0c1.25 0 2.42.237 3.512.713a9.147 9.147 0 0 1 2.85 1.925 9.149 9.149 0 0 1 1.926 2.85A8.707 8.707 0 0 1 18 9c0 1.25-.238 2.42-.712 3.512a9.148 9.148 0 0 1-1.925 2.85 9.148 9.148 0 0 1-2.85 1.926A8.707 8.707 0 0 1 9 18Zm2.8-4.8L8 9.4V4h2v4.6l3.2 3.2-1.4 1.4Z"
	})
});
export { SvgChangeHistory as ReactComponent };
